//第三方对接 - 翼支付 逻辑处理
import loadJS from './loadJS';
import { StaticToast, StaticLoading } from 'src/components/common';
import { getReturnUrl } from './pay';

type SimplePayOptions = {
  merchantNo: string;
  institutionCode: string;
  institutionType: string;
  signType: string;
  sign: string;
  platform: string;
  tradeType: string;
  outTradeNo: string;
  tradeNo: string;
  tradeAmt: string;
  tradeDesc: string;
  otherflow: string;
}

const bestPayJsSdkInit = () => {
  const bestPayJsSdkUrl = 'https://h5.bestpay.com.cn/common/js/bestpay-html5-3.0.js';
  console.info('1、准备初始化 翼支付',);
  return new Promise((resolve: (value) => void, reject: (reason?: any) => void): void => {
    StaticLoading.show();
    loadJS(bestPayJsSdkUrl, () => {
      console.log('2、加载SDK JS成功, 准备调用config方法')
      BestpayHtml5.config();
      console.log('3、调用config方法完成', BestpayHtml5)
      StaticLoading.hide();
      resolve(BestpayHtml5);
    })
  })
}

const bestPayRedirectAction = (status = '', payParams) => {
  if(status === 'success'){
    const returnUrl = getReturnUrl(payParams);
    window.location.replace(returnUrl);
  }if(status === 'fail' || status === 'cancel'){
    console.log('status',status);
    console.log('params',payParams);
    window.location.replace(`/hospital/orderdetail?orderId=${payParams.id}`);
  }
}

// 唤起简化版收银台
export const bestPaySimpleCheckout = (options: SimplePayOptions, payParams) => {
  bestPayJsSdkInit().then(BestpayHtml5 => {
    let { Payment: { payForSimpleCheckout = null } = {} } = BestpayHtml5;
    console.log('2、准备拉起翼支付', options)

    payForSimpleCheckout && payForSimpleCheckout(options, (res) => {
      console.log('成功', res)
      bestPayRedirectAction('success', payParams);
    }, res => {
      console.log('失败', res)
      StaticToast.error('支付失败');
      bestPayRedirectAction('fail', payParams);
    }, res => {
      bestPayRedirectAction('cancel', payParams);
      console.log('取消', res)
    })
  })
}


export default bestPayJsSdkInit;